import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "inline-flex align-items-center flex-nowrap white-space-nowrap" }
const _hoisted_2 = {
  key: 0,
  class: "mr-s1"
}
const _hoisted_3 = { class: "mr-s1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" -- ")

import BigNumber from 'bignumber.js';
import { format } from '@/utils/format';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { LP_TOKEN_DECIMALS } from '@/sdk/entities/constants/LP_TOKEN_DECIMALS';
import TooltipIcon from '@/components/tooltip/TooltipIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LpAmountFormat',
  props: {
    lpAmount: null,
    approx: { type: Boolean },
    isShort: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  lpAmount: BigNumber.Value;
  approx?: boolean;
  isShort?: boolean;
}



const { t } = useI18n();
const amount = computed(() => BigNumber(props.lpAmount));
const isZero = computed(() => amount.value.eq(0));
const isSmallAmount = computed(() => !isZero.value && amount.value.lt(10 ** -15));
const isPicoFormat = computed(() => !isSmallAmount.value && amount.value.lt(10 ** -6));
const isBigAmount = computed(() => amount.value.gte(10 ** 6));
const fullSymbol = computed(() =>
  (isSmallAmount.value || isPicoFormat.value) && !isZero.value ? t('pLpTokens') : t('lpTokens'),
);
const shortSymbol = computed(() =>
  (isSmallAmount.value || isPicoFormat.value) && !isZero.value ? 'pLP' : 'LP',
);

const formatAmount = computed(() => {
  if (!props.lpAmount) return;
  if (isZero.value) return '0';
  if (isSmallAmount.value) return '<0.001';
  if (isPicoFormat.value) {
    return format(amount.value.dividedBy(10 ** -12).toFixed(3), 11, { roundUp: true });
  } else {
    return !isBigAmount.value ? format(amount.value.toFixed(6), 14) : format(amount.value);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.lpAmount)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (__props.approx)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "~"))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formatAmount)), 1),
          _createElementVNode("span", null, _toDisplayString(__props.isShort ? _unref(shortSymbol) : _unref(fullSymbol)), 1),
          (_unref(isSmallAmount))
            ? (_openBlock(), _createBlock(TooltipIcon, {
                key: 1,
                tooltip: _unref(amount).toFixed(_unref(LP_TOKEN_DECIMALS))
              }, null, 8, ["tooltip"]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_4
        ], 64))
  ]))
}
}

})